import {z} from 'zod'

export const enum CONTRIBUTOR_MODEL {
    Name = 'name',
    Username = 'username',
    Email = 'email',
    Password = 'password',
    PasswordConfirmation = 'passwordConfirmation'
}

export const signupContributorFormSchema = z
    .object({
        [CONTRIBUTOR_MODEL.Name]: z.string().min(1, {message: 'validation:required_name'}).default(''),
        [CONTRIBUTOR_MODEL.Username]: z
            .string()
            .min(1, {message: 'validation:required_username'})
            .regex(/^[a-zA-Z0-9]+$/, {message: 'validation:username_alpha_numeric'})
            .default(''),
        [CONTRIBUTOR_MODEL.Email]: z
            .string()
            .min(1, {message: 'validation:email'})
            .email({
                message: 'validation:email_valid'
            })
            .default(''),
        [CONTRIBUTOR_MODEL.Password]: z
            .string()
            .min(6, {message: 'validation:password'})
            .regex(new RegExp(/^(?=.*[A-Z])(?=.*[0-9])(?=.*[^\w\s]).{6,32}/), {message: 'validation:password_complex'})
            .default(''),
        [CONTRIBUTOR_MODEL.PasswordConfirmation]: z.string().min(6, {message: 'validation:password'}).default('')
    })
    .refine(data => data[CONTRIBUTOR_MODEL.Password] === data[CONTRIBUTOR_MODEL.PasswordConfirmation], {
        path: [CONTRIBUTOR_MODEL.PasswordConfirmation],
        message: 'validation:confirm_password'
    })

export type ContributorValidationSchema = z.infer<typeof signupContributorFormSchema>
